import * as React from "react";
import { createContext, useContext } from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { calculateAvailableLabelWidth } from "../../../../utils/steps/PrescriptionFormStep/utils/calculate-available-label-width.js";
const PrescriptionFormLayoutContext = createContext(null);
PrescriptionFormLayoutContext.displayName = "PrescriptionFormLayoutContext";
const usePrescriptionFormLayout = () => {
  const context = useContext(PrescriptionFormLayoutContext);
  if (context === null) {
    throw new Error("No PrescriptionFormLayoutContext available.");
  }
  return context;
};
const PrescriptionFormLayoutProvider = ({ children }) => {
  const [labelAmountOfLines, setLabelAmountOfLines] = React.useState({});
  const [layout, setLayout] = React.useState("unknown");
  const [availableLabelWidth, setAvailableLabelWidth] = React.useState(0);
  const breakpoint = MediaQuery.useBreakpoint();
  const hasLabelsWithThreeLines = Object.values(labelAmountOfLines).some((line) => line >= 3);
  const wrapperRef = React.useRef(null);
  const handleAvailableWidth = React.useCallback(() => {
    if (wrapperRef.current) {
      setAvailableLabelWidth(calculateAvailableLabelWidth(wrapperRef.current, breakpoint));
    }
  }, [breakpoint]);
  React.useEffect(() => {
    handleAvailableWidth();
    window.addEventListener("resize", handleAvailableWidth);
    return () => window.removeEventListener("resize", handleAvailableWidth);
  }, [handleAvailableWidth]);
  React.useEffect(() => {
    if (Object.values(labelAmountOfLines).length === 0) {
      setLayout("unknown");
      return;
    }
    if (hasLabelsWithThreeLines && breakpoint === "PHONE") {
      setLayout("singleColumn");
    } else {
      setLayout("tripleColumn");
    }
  }, [hasLabelsWithThreeLines, labelAmountOfLines, breakpoint]);
  return /* @__PURE__ */ React.createElement(
    PrescriptionFormLayoutContext.Provider,
    {
      value: {
        layout,
        setLabelAmountOfLines,
        availableLabelWidth
      }
    },
    /* @__PURE__ */ React.createElement("div", { ref: wrapperRef }, children)
  );
};
export {
  PrescriptionFormLayoutContext,
  PrescriptionFormLayoutProvider,
  usePrescriptionFormLayout
};
//# sourceMappingURL=PrescriptionFormLayoutContext.js.map
